/**
 * Canonical public URL for a game (slug preferred, id fallback for 301).
 */
export function gamePublicPath(game) {
    if (!game) {
        return '/results';
    }

    const key = game.slug || game.id;
    return key ? `/games/${key}` : '/results';
}
